import { ChartLineDataset } from "pptxgenjs"
import * as Conf from "../configuration"
import * as DemographyDomain from "../../../domain/sfp/demography-domain"
import { Demography } from "../../../model"

export function createYears(start: number, end: number): number[] {
	const years: number[] = []
	for (let y = start; y <= end; y++) years.push(y)
	return years
}

export function createDemographyData(
	demographies: Demography[],
	years: number[],
	referenceYear? : number
): [ChartLineDataset] {
	const recentYearDemography = demographies.length > 0 && demographies.reduce((max, dem) => (max.year > dem.year) ? max : dem);

	const dataset: ChartLineDataset = {
		labels: years.map(y => y.toString()),
		name: "Population",
		values: years.map(y => {
			const demography = DemographyDomain.findByYear(demographies, y) || (referenceYear && y > referenceYear && recentYearDemography)
			return demography ? demography.population : null
		})
	}

	return [dataset]
}

export function formatCurrency(
	locale: string,
	currency: string,
	value: number,
	roundness?: Conf.RoundnessValue,
): string {
	switch (roundness) {
		case "nearest-thousand":
		case "nearest-whole-number":
			let formatter = new Intl.NumberFormat(locale, {
				currency,
				maximumFractionDigits: 0,
				minimumFractionDigits: 0,
				style: "currency"
			})
			switch (roundness) {
				case "nearest-thousand":
					return formatter.format(value / 1000).replace(/^(.*\s)(.)$/, "$1k$2")
				case "nearest-whole-number":
					return formatter.format(value)
			}
		default:
			formatter = new Intl.NumberFormat(locale, { currency, style: "currency" })
			return formatter.format(value)
	}
}

export function formatDate(date: Date): string {
	const day = date.getDate()
	const month = date.getMonth()
	const year = date.getFullYear()
	return `${day}/${month}/${year}`
}

export function formatTitle(title: string, numbers: number[]): string {
	return `${numbers.join(".")}. ${title}`
}

export function toInches(cm: number): number {
	return Math.round((cm / 2.54) * 10) / 10
}

export function isArrayAllValuesZero(item: any[]): item is any[] {
	return item.every((val, i, arr) => val === 0 || val === null)
}


// WEBPACK FOOTER //
// ./src/component/management-report/generator/utils.ts